function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
var _interceptors = new WeakMap(), _runResponseInterceptors = new WeakSet();
export class FetcherInterceptorManager {
    get interceptors() {
        return _class_private_field_get(this, _interceptors);
    }
    add(interceptor) {
        _class_private_field_get(this, _interceptors).push(interceptor);
    }
    remove(interceptor) {
        const index = _class_private_field_get(this, _interceptors).indexOf(interceptor);
        if (!~index) return;
        _class_private_field_get(this, _interceptors).splice(index, 1);
    }
    clear() {
        _class_private_field_set(this, _interceptors, []);
    }
    runRequestInterceptors(request) {
        var _this = this;
        return _async_to_generator(function*() {
            let req = request;
            for (const interceptor of _class_private_field_get(_this, _interceptors)){
                if (interceptor.request) {
                    req = yield interceptor.request(req);
                }
            }
            return req;
        })();
    }
    // @distributedlab/web-kit
    //
    runResponseInterceptors(response) {
        var _this = this;
        return _async_to_generator(function*() {
            return _class_private_method_get(_this, _runResponseInterceptors, runResponseInterceptors).call(_this, response, 'response');
        })();
    }
    runErrorInterceptors(response) {
        var _this = this;
        return _async_to_generator(function*() {
            return _class_private_method_get(_this, _runResponseInterceptors, runResponseInterceptors).call(_this, response, 'error');
        })();
    }
    constructor(interceptors){
        _class_private_method_init(this, _runResponseInterceptors);
        _class_private_field_init(this, _interceptors, {
            writable: true,
            value: []
        });
        if (interceptors) {
            _class_private_field_set(this, _interceptors, [
                ...interceptors
            ]);
        }
    }
} /*#__PURE__*/  /*#__PURE__*/ 
function runResponseInterceptors(response, fnName) {
    return _runResponseInterceptors1.apply(this, arguments);
}
function _runResponseInterceptors1() {
    _runResponseInterceptors1 = _async_to_generator(function*(response, fnName) {
        let resp = response;
        for (const interceptor of _class_private_field_get(this, _interceptors)){
            const fn = interceptor[fnName];
            if (fn) resp = yield fn(resp);
        }
        return resp;
    });
    return _runResponseInterceptors1.apply(this, arguments);
}

//# sourceMappingURL=data:application/json;base64,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